// PER-SITE STAFFING MODEL — "this surgery center runs CRNA-only; the children's hospital runs ACT".
//
// Undated on purpose. How a site practises is a property of the SITE, not of a particular day, so this
// key carries no date suffix and clearAllDayOverlays (boardViewHelpers) cannot wipe it when a day is
// re-simulated. Same reasoning as boardPrefs.ts.
//
// Every read is defensive: junk JSON, a non-object payload, an unknown model value, or storage that
// throws (private mode) all fall back to the shipped default rather than poisoning the coverage numbers.

import { StaffingModel, STAFFING_MODELS, DEFAULT_STAFFING_MODEL } from './manpowerCoverage.ts';

export const SITE_STAFFING_MODEL_KEY = 'oc-site-staffing-model';

const isModel = (v: unknown): v is StaffingModel =>
  typeof v === 'string' && (STAFFING_MODELS as readonly string[]).includes(v);

/** hospitalId -> model, carrying ONLY entries that are valid today. */
export const loadSiteStaffingModels = (): Record<string, StaffingModel> => {
  let raw: string | null = null;
  try { raw = localStorage.getItem(SITE_STAFFING_MODEL_KEY); } catch { return {}; }
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    const out: Record<string, StaffingModel> = {};
    for (const [hid, m] of Object.entries(parsed)) if (isModel(m)) out[hid] = m;
    return out;
  } catch { return {}; }
};

export const saveSiteStaffingModels = (models: Record<string, StaffingModel>): void => {
  try { localStorage.setItem(SITE_STAFFING_MODEL_KEY, JSON.stringify(models)); } catch { /* private mode */ }
};

/** The resolver dayCoverage wants: an unset or unknown site falls back to the default. */
export const staffingModelResolver =
  (models: Record<string, StaffingModel>) =>
    (hospitalId: string): StaffingModel => models[hospitalId] ?? DEFAULT_STAFFING_MODEL;
